import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-limpiar-flotante',
  templateUrl: './limpiar-flotante.component.html',
  styleUrl: './limpiar-flotante.component.scss',
  standalone: false
})
export class LimpiarFlotanteComponent {

  @Output() limpiar: EventEmitter<void> = new EventEmitter<void>();

  onClick() {
    this.limpiar.emit();
  }

}
